<template>
  <div id="jumbotron">
    <div class="container">
      <h1>English Classes<br>for all ages</h1>
    </div>
  </div>

  <div class="container pt-5 mt-5">
    <div class="row m-0">
      <div class="col-12 col-md-7">
        <h2 class="text-primary mb-4">
          When it comes to studying how to learn English we take great care in our language courses to make sure our students are placed in the class that's right for them.
        </h2>
    
        <p>
          In fact, this is so important to us that we offer <strong>free placement tests</strong> before registration – only after having carefully assessed an individual’s level of English, can we advise on the right choice of class and course for their ability and age.
        </p>
    
        <p>
          And with 15 levels to choose from, we’re confident we can place every student in the English class that’s right for them.
        </p>
    
        <p>
          So, whether:
        </p>
    
        <ul class="pb-4">
          <li>You’re a young learner, a student or a young adult looking for the best way to learn English.</li>
          <li>You are at a local, international or home school.</li>
          <li>You want an internationally-recognised exam or you want to learn without the pressure of tests.</li>
          <li>You want to obtain the right certificates to help gain entry to an overseas university.</li>
          <li>You want to do better at school.</li>
          <li>You’re a working adult who wants to brush up on your English speaking language skills and grammar.</li>
        </ul>

        <div class="pb-5">
          <a href="https://english-matters.s3.ap-southeast-1.amazonaws.com/files/English+Matters+2025+Term+Dates.pdf" target="_blank" class="btn btn-secondary px-4 py-2 fw-bold me-5">2025 Term Dates</a>
          <a href="https://english-matters.s3.ap-southeast-1.amazonaws.com/files/2025+Fee+Structure+%26+Timetable.pdf" target="_blank" class="btn btn-secondary px-4 py-2 fw-bold">Fee Structure</a>
        </div>
      </div>
    </div>

    <div class="row m-0">
      <div class="col-12 col-md-6">
        <div class="section-container p-5">
          <h2 class="section-title text-secondary">5-11</h2>
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/classes+5+to+11.webp" 
                alt="Classes for 5 to 11 years old" class="w-100 shadow">
        </div>
      </div>
      <div class="col-12 col-md-6 bg-color p-5">
        <h3 class="text-primary">
          Choosing topics that will appeal to young learners, we build up their confidence and their skills in all areas of the language.
        </h3>
        <p class="fw-bold">
          We have 5 different levels for kids learning English from ages 5-11, based not just on the student’s age but also their level of English and their own particular needs.
        </p>

        <router-link class="btn btn-primary px-4 py-2 my-4" to="/english-classes/english-class-for-5-11-years-old-kids/">
          Learn More
        </router-link>
      </div>
    </div>

    <div class="row flex-row-reverse m-0">
      <div class="col-12 col-md-6">
        <div class="section-container p-5">
          <h2 class="section-title text-secondary">12-19</h2>
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/classes+12+to+19.webp" 
                alt="Classes for 12 to 19 years old" class="w-100 shadow">
        </div>
      </div>
      <div class="col-12 col-md-6 bg-color p-5">
        <h3 class="text-primary">
          The English grammar becomes increasingly advanced, with the higher levels aiming for natural fluency.
        </h3>
        <p class="fw-bold">
          We have 7 levels for students aged 12-19, with each level focusing in greater depth on the key skills of writing, speaking, reading and listening.
        </p>
        <p>
          3 external exam classes, focusing on the internationally-recognised FCE, CAE and CPE English exams.
        </p>

        <p>
          For more information on our approach to exams, <router-link to="/english-classes/cambridge-english-exams-in-petaling-jaya/">click HERE</router-link>.
        </p>

        <router-link class="btn btn-primary px-4 py-2 my-4" to="/english-classes/english-class-for-12-19-years-old-kids/">
          Learn More
        </router-link>
      </div>
    </div>
    
    <div class="row m-0">
      <div class="col-12 col-md-6">
        <div class="section-container p-5">
          <h2 class="section-title text-secondary">Adults</h2>
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/classes+adult.webp" 
                alt="Classes for Adults" class="w-100 shadow">
        </div>
      </div>
      <div class="col-12 col-md-6 bg-color p-5">
        <h3 class="text-primary">
          We recognise that adult learners, especially those who work, have so many demands on their time that it can sometimes be hard to commit to regular classes.
        </h3>
        <p class="fw-bold">
          For this reason, here at English Matters we offer you a unique opportunity to learn at your own pace and in accordance with your own particular needs.
        </p>
        <p>
          You can choose one (or more) of 2 different options:
        </p>
        <ul>
          <li>
            Private one-on-one lessons, completely tailored to each individual student’s needs – anything from elementary pronunciation or conversation classes to advanced business writing. We can also generally provide these individual sessions at a time and day of your choosing. We have the most affordable rates for a package of 12 lessons at RM165 per private class. Terms & Conditions apply.
          </li>
          <li>
            Class sessions for groups of 4 or more students. So if you and your friends or work colleagues want to come together to improve your English, then get in touch with us for more information.
          </li>
        </ul>

        <router-link class="btn btn-primary px-4 py-2 my-4" to="/english-classes/english-class-for-adults/">
          Learn More
        </router-link>
      </div>
    </div>
  </div>

  <div id="creativeClass" class="bg-color py-5 mt-5">
    <div class="container">
      <h3 class="text-center text-secondary">Creative Writing</h3>
      <div class="row m-0">
        <div class="col-12 col-md-6 px-5">
          <p class="fw-bold text-primary">For ages 5-17 years old</p>
          <p>At English Matters, our Creative Writing class is designed for students aged 5-17, with three tailored levels: Beginner, Junior, and Intermediate.</p>
          <p>If your child has a passion for writing or shows creative potential, this course offers the perfect environment to nurture their skills. Through engaging lessons, students will explore a variety of writing styles, allowing them to express themselves while developing critical creative thinking abilities. Whether they’re just starting or building on their writing talents, this class provides a fun and inspiring journey into the world of storytelling and expression.</p>

          <router-link class="btn btn-primary px-4 py-2 my-4" to="/english-classes/school-holidays-english-class/">
            Learn More
          </router-link>
        </div>
        <div class="col-12 col-md-6">
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/classes+creative+writing.webp" 
                alt="Classes for Creative Writing" class="w-100 shadow">
        </div>
      </div>
    </div>
  </div>

  <ContactUs />
</template>

<style scoped>
#jumbotron {
  background-color: #2e1aaf;
  background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/celebration.png");
  background-size: cover;
  background-position: right bottom -200px;
  background-repeat: no-repeat;
  padding-top: 20vh;
  color: white;
  height: 55vh;
}

.container { max-width: 1100px; }

h1 { font-size: 3.5em; }
h2 { font-size: 1.8em; }
h3 { font-size: 1.5em; }

.section-container {
  background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/chat-bubble-4.png");
  background-position: left 0 top 100px;
  background-repeat: no-repeat;
  text-align: center;
  margin-bottom: 3em;
}
.section-title {
  font-size: 7em;
  text-align: left;
  padding-left: 0.2em;
}
.section-container img {
  max-width: 375px;
  height: auto;
  margin: auto;
}
.bg-color {
  background-color: #F4F3F9;
}

#creativeClass h3 {
  font-size: 7em;
}

#creativeClass img {
  max-width: 450px;
  margin: auto;
}
</style>

<script>
import ContactUs from '../components/ContactUs.vue';
export default {
  components: { ContactUs }
}
</script>